var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddfileIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2C5.0095 2 4 3.0095 4 4.25V19.75C4 20.9905 5.0095 22 6.25 22H12.8203C12.3928 21.5555 12.0278 21.0515 11.7393 20.5H6.25C5.8365 20.5 5.5 20.1635 5.5 19.75V4.25C5.5 3.8365 5.8365 3.5 6.25 3.5H12V7.75C12 8.9905 13.0095 10 14.25 10H18.5V11.085C19.0225 11.166 19.5265 11.3035 20 11.502V9.25C20 9.04275 19.916 8.85541 19.7803 8.71973L13.2803 2.21973C13.1446 2.08404 12.9572 2 12.75 2H6.25ZM13.5 4.56055L17.4395 8.5H14.25C13.8365 8.5 13.5 8.1635 13.5 7.75V4.56055ZM17.5 12C14.4625 12 12 14.4625 12 17.5C12 20.5375 14.4625 23 17.5 23C20.5375 23 23 20.5375 23 17.5C23 14.4625 20.5375 12 17.5 12ZM17.5 13.5C17.776 13.5 18 13.724 18 14V17H21C21.276 17 21.5 17.224 21.5 17.5C21.5 17.776 21.276 18 21 18H18V21C18 21.276 17.776 21.5 17.5 21.5C17.224 21.5 17 21.276 17 21V18H14C13.724 18 13.5 17.776 13.5 17.5C13.5 17.224 13.724 17 14 17H17V14C17 13.724 17.224 13.5 17.5 13.5Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddfileIco);
export default __webpack_public_path__ + "static/media/addfile-ico.039b1a99.svg";
export { ForwardRef as ReactComponent };